import Box from '@risk-smart/themed-cloudscape-components/box';
import Link from '@risk-smart/themed-cloudscape-components/link';
import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import Button from '@risksmart-app/components/src/button';
import Modal from '@risksmart-app/components/src/modal';
import type { FC } from 'react';

import { riskDetailsUrl } from '@/utils/urls';

import type { RiskBubbleMember } from '../riskBubbleChartOptions';

export interface RiskBubbleCluster {
  members: RiskBubbleMember[];
  likelihood: string;
  impact: string;
  rating: string;
}

export interface RiskBubbleClusterModalProps {
  cluster: RiskBubbleCluster;
  copy: {
    title: string;
    likelihood: string;
    impact: string;
    rating: string;
    close: string;
    closeModal: string;
  };
  onOpenRisk: (id: string) => void;
  onDismiss: () => void;
}

/**
 * The risks a cluster bubble stands for (RSP-7294). A bubble can only open
 * one risk, so a bubble standing for several lists them here and lets the
 * reader pick. Every member is a real link, so open-in-new-tab still works.
 */
export const RiskBubbleClusterModal: FC<RiskBubbleClusterModalProps> = ({
  cluster,
  copy,
  onOpenRisk,
  onDismiss,
}) => (
  <Modal
    data-testid={'risk-bubble-cluster-modal'}
    visible={true}
    size={'small'}
    header={copy.title}
    closeAriaLabel={copy.closeModal}
    onDismiss={onDismiss}
    footer={
      <Box float={'right'}>
        <Button variant={'normal'} onClick={onDismiss}>
          {copy.close}
        </Button>
      </Box>
    }
  >
    <SpaceBetween size={'m'}>
      <Box variant={'p'} color={'text-body-secondary'}>
        {`${copy.rating}: ${cluster.rating}`}
        <br />
        {`${copy.likelihood}: ${cluster.likelihood}`}
        <br />
        {`${copy.impact}: ${cluster.impact}`}
      </Box>
      <ul className={'list-none p-0 m-0 flex flex-col gap-2'}>
        {cluster.members.map((member) => (
          <li key={member.id}>
            <Link
              href={riskDetailsUrl(member.id)}
              onFollow={(event) => {
                event.preventDefault();
                onOpenRisk(member.id);
              }}
            >
              {member.name}
            </Link>
          </li>
        ))}
      </ul>
    </SpaceBetween>
  </Modal>
);
